import React from "react";
import { Tag } from "@dishopsaas/design-system";
import { getOrderStatusLabel } from "../../../utils";
export default function OrderStatusIndicator({ order, isMobile, isPast = false }) {
  const { label, icon, color } = getOrderStatusLabel(order, isMobile, isPast);

  return <Tag label={label} color={color} borderRadius={4} icon={icon} style={{ maxWidth: 'max-content' }}></Tag>;
}
